<template>
  <div class="ChangePassword">
    <!-- <div class="list">
      <div class="list-tit">信息提交成功，等待审核中</div>
    </div> -->
    <div class="btn">
    <div class="confirmBnt bg-color-red" @click="confirm">返回首页</div>
    </div>
  </div>
</template>

<style scoped>
    .list-tit{
      font-size: .3rem;
      margin-top: .5rem;
    }
    
</style>
<script>
import { mapGetters } from "vuex";
import sendVerifyCode from "@mixins/SendVerifyCode";
import Upload from '@/components/Upload';
import { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { registerVerify, bindingPhone } from "@api/user";


export default {
  name: "Shenhe",
  components: {
    Upload,
  },
  props: {},
  data: function() {
    return {
      captcha: "",
      shopname:"",
      time:"",
      phone: "" //手机号
    };
  },
  mixins: [sendVerifyCode],
  computed: mapGetters(["userInfo"]),
  mounted: function() {},
  methods: {
    async confirm() {
        this.$router.push({ path: "/"});
    },
  },
  fileChange(file) {
    // 因为file是个FormData格式的对象所以可以直接通过接口开始上传，不需要做多余操作
    this.axios.post('/upload/thumb', file).then(res => {
        console.log(res.data.datas)
        this.img = this.HTTP + res.data.datas
    }, err => {
        console.log(err)
    })
},
};
</script>

<style scoped>
.ChangePassword{
  background-image: url(http://tieyige.fsrcwl.cn/images/shenhe.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 812px;
  position: relative;
}
.btn{
  position: absolute;
  bottom: 8%;
  width: 100%;

}
</style>